/**
 * Where the UI opens its WebSockets (2026-09-10).
 *
 * Never the NAME `localhost`. Measured in the owner's own Chrome: from a page
 * at http://localhost:8000, a socket to ws://localhost:8000 never left the
 * browser (no proxy, both loopback families listening, HTTP to the same host
 * fine), while sockets to ws://127.0.0.1:8000 and ws://[::1]:8000 reached the
 * server at once. The same rule already holds server-side for Ollama
 * (`OLLAMA_BASE` is the literal, never `localhost:11434`). So a page on
 * `localhost` dials the loopback literal; the server's origin guard treats
 * the loopback family on one port as one origin. Every socket in the UI goes
 * through here — a second `${location.host}` socket URL is the bug again.
 */
export const LOOPBACK_LITERAL = "127.0.0.1";

export function socketHost(loc: { hostname: string; host: string; port: string } = window.location): string {
	if (loc.hostname.toLowerCase() !== "localhost") return loc.host;
	return loc.port ? `${LOOPBACK_LITERAL}:${loc.port}` : LOOPBACK_LITERAL;
}

export function wsUrl(path: string, loc: { protocol: string; hostname: string; host: string; port: string } = window.location): string {
	const proto = loc.protocol === "https:" ? "wss:" : "ws:";
	return `${proto}//${socketHost(loc)}${path.startsWith("/") ? path : `/${path}`}`;
}
